import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    sage: {
      50:  '#f0f7f3',
      100: '#d5eadd',
      200: '#aed4bf',
      300: '#87bda1',
      400: '#7B9E87',
      500: '#5d8069',
      600: '#4a6655',
      700: '#3a5044',
      800: '#2d3e34',
      900: '#1f2c25',
    },
  },
  fonts: {
    heading: `'Playfair Display', Georgia, serif`,
    body: `'Lato', -apple-system, BlinkMacSystemFont, sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: '#FAF7F2',
        color: '#3D3535',
      },
    },
  },
});

export default theme;
